import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Calendar from 'react-calendar';
import * as commonActions from './../../actions/commonActions';
import { connect } from 'react-redux';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import OutsideAlerter from "../HelperComponents/CalOutsideAlerter";
import styles from './DateSelector.less';
var stylesModal = require('../Report/Report.less');
import '../../theme/styles/styles.css';
import { setDirection, getSelectedDate, isOneYearRangeSelected, getFormattedDate } from './../../utils/utils';
import moment from 'moment';
import Modal from 'react-modal';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

const directionData = [
  { "classNames": "chrtDropdown", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "btnText", "elementType": "normal", "applyTo": "all", "tagNames": "button" },
  { "classNames": "graphCalendarDiv", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "rptCalendarDiv", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "endClndr", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "startClndr", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
  { "classNames": "datepickerBtn", "elementType": "normal", "applyTo": "all", "tagNames": "button" },
  { "classNames": "SOAdatePart", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
];
const component = ["alldealReport", "statementOfAccount"];

@connect(
  state => ({
    socketData: state.dashboardRoot.instrumentListReducer.socketData,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    openCalender: state.dashboardRoot.commonReducer.openCalender,
    yearList: state.auth.userDetail.yearList,
    thresholdCount:state.dashboardRoot.reportReducer.thresholdCount,
    derivedEndDate: state.dashboardRoot.reportReducer.derivedEndDate
  }),
  { ...commonActions })
export default class DateSelector extends Component {
  static propTypes = {
    resetThresholdState:PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      id: 'today',
      showCalendarTitle: getFormattedDate(new Date()),
      calendarTitle: getFormattedDate(new Date()),
      showValidation: false,
      validationMsg: "",
      yearListHeading: "",
      isOneYear: false,
      isPrevYearDate: false,
      prevYearDate: "",
      selectedYearObj: this.props.yearList[0],
      currentDate: getFormattedDate(new Date()),
      startDate: getFormattedDate(new Date()),
      endDate: getFormattedDate(new Date())
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.thresholdCount !== nextProps.thresholdCount) {
      this.setState({ showValidation: true, validationMsg: `The record count is greater than the max display limit of ${this.props.thresholdCount}. You can try again by changing the End Date to ${this.props.derivedEndDate}.` });
      this.props.resetThresholdState();
    } else if (this.props.selectedLang !== nextProps.selectedLang) {
      setDirection(ReactDOM.findDOMNode(this), directionData, nextProps.selectedLang);
    }
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    if (this.props.component === "Chart" || this.props.component === "DeliveryCompleted") {
      this.setState({
        startDate: getFormattedDate(this.props.startDate),
        endDate: getFormattedDate(this.props.endDate),
        calendarTitle: getFormattedDate(this.props.startDate) + " - " + getFormattedDate(this.props.endDate)
      }, () => this.setCalenarTitle())
    }
    if (this.props.component === "DeliveryCompleted") {
      function parseDDMMYYYY(dateStr) {
        if (!dateStr) return null;

        const [day, month, year] = dateStr.split("-").map(Number);

        // Months are 0-based in JS Date
        return new Date(year, month - 1, day);
      }
      this.setState({
        startDate: getFormattedDate(parseDDMMYYYY(this.props.startDate)),
        endDate: getFormattedDate(parseDDMMYYYY(this.props.endDate)),
        calendarTitle: getFormattedDate(parseDDMMYYYY(this.props.startDate)) + " - " + getFormattedDate(parseDDMMYYYY(this.props.endDate))
      }, () => this.setCalenarTitle())
    }
    else {
        this.setCalenarTitle();
    }
    this.setState({ yearListHeading: this.props.yearList[0].YEAR });
    setDirection(ReactDOM.findDOMNode(this), directionData, this.props.selectedLang);
    var hoverElementsClassNames = [
      { "elmToHover": thisComponent.getElementsByClassName('applyBtn')[0], "classNames": "applyBtn" },
      { "elmToHover": thisComponent.getElementsByClassName('cancelBtns')[0], "classNames": "cancelBtns" },
      { "elmToHover": thisComponent.getElementsByClassName('react-calendar__tile--hasActive')[0], "classNames": "react-calendar__tile--hasActive" }

    ];
    for (var i = 0; i < thisComponent.getElementsByTagName("button").length; i++) {
      var elmToHover = thisComponent.getElementsByTagName("button")[i];
      var className = null;
      hoverElementsClassNames.push({ "elmToHover": elmToHover, "classNames": className })
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.disabled !== prevProps.disabled) {
      this.setState({
        startDate: getFormattedDate(new Date()),
        endDate: getFormattedDate(new Date()),
        calendarTitle: getFormattedDate(new Date()),
        id: "today"
      }, () => { this.setCalenarTitle(); 
        this.props.setStartDate(getFormattedDate(new Date()));
        this.props.setEndDate(getFormattedDate(new Date()));
      });
    }
  }

  componentWillUnmount() {
    this.props.onClickCalender(false, this.props.keyValue);
  }

  setCalenarTitle = () => {
    if (this.state.calendarTitle) { // 2023/05/24
      let calenderTitle = this.state.calendarTitle.split('-').map((date) => moment(date).format('DD-MM-YYYY')).join(' - ');  // 24-05-2023 - 31-05-2023
      this.setState({ showCalendarTitle: calenderTitle })
    }
  }

  minDate = () => {
    if (this.state.id === "custom") {
      let splitDate = this.state.currentDate.split('-');
      return new Date(splitDate[0]);
    } else if (this.state.id === "prevYearDate" || (this.state.prevYearDate && this.state.prevYearDate.length > 0)) {
      let splitDate = this.state.prevYearDate.split('-');
      return new Date(splitDate[0]);
    } else return new Date(this.state.startDate);
  }

  maxDate = () => {
    if (this.state.id === "prevYearDate" || (this.state.prevYearDate && this.state.prevYearDate.length > 0)) {
      let splitDate = this.state.prevYearDate.split('-');
      return new Date(splitDate[1]);
    } else {
      return new Date();
    }
  }

  showCalender = (eventKey) => {
    var val = eventKey;
    let splitDate = this.state.calendarTitle.split(' - ');
    this.setState({ id: val });
    if (val === "custom") {
      this.splitStartEndDate(getSelectedDate(val, this.state.selectedYearObj.FROM_DATE), val);
      this.setState({
        startDate: getFormattedDate(splitDate[0]),
        endDate: getFormattedDate(splitDate[1] ? splitDate[1] : splitDate[0])
      });
      this.props.setStartDate(getFormattedDate(splitDate[0]));
      this.props.setEndDate(getFormattedDate(splitDate[1] ? splitDate[1] : splitDate[0]))

    } else if (val === "prevYearDate") {
      this.props.onClickCalender(true, this.props.keyValue);
      this.setState({
        startDate: getFormattedDate(splitDate[0]),
        endDate: getFormattedDate(splitDate[1]),
        currentDate: getFormattedDate(splitDate[0]) + ' - ' + getFormattedDate(splitDate[1]),
        calendarTitle: getFormattedDate(splitDate[0]) + ' - ' + getFormattedDate(splitDate[1])
      }, () => this.setCalenarTitle());
      this.props.setStartDate(getFormattedDate(splitDate[0]))
      this.props.setEndDate(getFormattedDate(splitDate[1]))
    } else {
      this.props.onClickCalender(false, this.props.keyValue);
      this.splitStartEndDate(getSelectedDate(val, this.state.selectedYearObj.FROM_DATE), val);
    }
  }

  splitStartEndDate = (date, id) => {
    let splitDate = date.split(' - ');
    if (id === 'today' || id === 'yest') {
      this.setState({
        startDate: date,
        endDate: date,
        currentDate: date,
        calendarTitle: date
      }, () => {
        this.setCalenarTitle()
        this.props.onClickFilter();         // After filter change ==> call API
      });
      this.props.setStartDate(date)
      this.props.setEndDate(date)
    } else if (id === 'custom') {
      this.props.onClickCalender(true, this.props.keyValue);
      this.setState({ currentDate: getFormattedDate(splitDate[0]) + ' - ' + getFormattedDate(splitDate[1]) }) // ['2022/04/01', '2023/05/24']
    } else {
      this.setState({
        startDate: getFormattedDate(splitDate[0]),
        endDate: getFormattedDate(splitDate[1]),
        currentDate: getFormattedDate(splitDate[0]) + ' - ' + getFormattedDate(splitDate[1]),
        calendarTitle: getFormattedDate(splitDate[0]) + ' - ' + getFormattedDate(splitDate[1])
      }, () => {
        this.setCalenarTitle();
        this.props.onClickFilter();
      });
      this.props.setStartDate(getFormattedDate(splitDate[0]))
      this.props.setEndDate(getFormattedDate(splitDate[1]))
    }
  }

  applyDate = () => {
    if (moment(this.state.endDate).isBefore(this.state.startDate)) {
        this.props.onClickCalender(true, this.state.keyValue);
        this.setState({
            showValidation:true,
            validationMsg:"dateSelectorErrMsg"
        });
    } else if (this.props.component === "Chart" && moment(this.state.endDate).diff(this.state.startDate, 'days') < 6) {
        this.props.onClickCalender(true, this.state.keyValue);
        this.setState({
            showValidation:true,
            validationMsg:"graphErrMsg"
        });
    } else if (isOneYearRangeSelected(this.state.id, this.state.startDate, this.state.endDate)) {
        this.props.onClickCalender(false, this.props.keyValue);
        this.props.onClickFilter();
        this.setState({ calendarTitle: this.state.startDate + ' - ' + this.state.endDate }, () => this.setCalenarTitle()); //['2023/05/01', '2023/05/18']
    } else {
        this.props.onClickCalender(true, this.props.keyValue);
        this.setState({ showValidation: true });
        this.setState({ validationMsg: "oneYearDateSelectorErrMsg" });
    }
  }

  onStartDateChange = startDate => {
    this.setState({ startDate: getFormattedDate(startDate) });
    this.props.setStartDate(getFormattedDate(startDate))
  }

  onEndDateChange = endDate => {
    this.setState({ endDate: getFormattedDate(endDate) });
    this.props.setEndDate(getFormattedDate(endDate))
  }

  onYearchange = (eventKey, event) => {
    const dropdownSelect = eventKey.split('+');
    const yearListObj = JSON.parse(dropdownSelect[0]);
    const dropdownHeading = event.target.textContent || event.target.innerText;
    this.props.setYearHeading(dropdownHeading)
    if (dropdownHeading !== "Current Year") { // If it's prevYear from dropdown
      this.setState({
        yearListHeading: dropdownHeading,
        selectedYearObj: yearListObj,
        isPrevYearDate: true,
        id: "prevYearDate",
        prevYearDate: getFormattedDate(yearListObj.FROM_DATE) + ' - ' + getFormattedDate(yearListObj.TO_DATE) // Set prevYear from/to date for calender validation
      }, () => {
        this.splitStartEndDate(getSelectedDate(this.state.id, this.state.prevYearDate), this.state.id)   // For current Year set by default id-> today 
      })
    } else if (dropdownHeading === "Current Year") { // If it's current year from dropdown
      this.props.onClickCalender(false, this.props.keyValue);
      this.setState({
        yearListHeading: dropdownHeading,
        selectedYearObj: yearListObj,
        isPrevYearDate: false,
        id: "today",
        prevYearDate: ""
      }, () => {
        this.splitStartEndDate(getSelectedDate(this.state.id, yearListObj.FROM_DATE), this.state.id);    // For current Year set by default id-> today 
      });
    }
  }

  resetDateRange = () => {
    let splitDate = this.state.calendarTitle.split(' - ');
    this.setState({
      startDate: getFormattedDate(splitDate[0]),
      endDate: getFormattedDate(splitDate[1] ? splitDate[1] : splitDate[0])
    })
    this.props.setStartDate(getFormattedDate(splitDate[0]))
    this.props.setEndDate(getFormattedDate(splitDate[1] ? splitDate[1] : splitDate[0]))

  }

  onCancelDate = () => {
    this.props.onClickCalender(false, this.props.keyValue);
    this.resetDateRange();
  }

  closeValidationModal = () => {
    const errorMessages = ["graphErrMsg", "oneYearDateSelectorErrMsg", "dateSelectorErrMsg"];
    if (errorMessages.includes(this.state.validationMsg)) {
      this.resetDateRange();
    }
    if(this.state.id === "custom" || this.state.id === "prevYearDate"){
      this.props.onClickCalender(true, this.state.keyValue);
    } 
    this.setState({ showValidation: false, validationMsg: "" });
  }

  checkComponent = (val) => {
    if (component.some(i => val === i)) {
      return true;
    } else return false;
  }
  afterOpenModal = () => {
    const thisComponent = this.refs.errorMSG;
    const elementsData = [
      { "classNames": "closeBtn", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      { "classNames": "button-l", "elementType": "normal", "applyTo": "single", "tagNames": "button" },
    ];
    const directionData = [
      { "classNames": "header", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "commonCloseIcon", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "commonMsgDir", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "button-l", "elementType": "normal", "applyTo": "single", "tagNames": "button" },
    ];
    setDirection(thisComponent, directionData, this.props.selectedLang);
    const hoverElementsClassNames = [
      { "elmToHover": thisComponent.getElementsByClassName("closeBtn")[0], "classNames": "closeBtn" },
      { "elmToHover": thisComponent.getElementsByClassName("button-l")[0], "classNames": "button-l" },

    ];
  }
  render() {
    const { openCalender, id, keyValue, component } = this.props;
    return (
        <div className={`${component !== 'Chart' ? `${styles.ranges} ` + this.props.selectedCssColor : `${styles.ranges} ${styles.chrtoptions} ` + this.props.selectedCssColor}`} id="secondwrapper">                
            {this.props.yearList && this.props.yearList.length > 1 && this.checkComponent(this.props.keyValue) ?
                <div className={`${styles.yearSelectionWrapper}`}>
                    <DropdownButton title={this.state.yearListHeading} id="bg-nested-dropdown" disabled={this.props.disabled ? this.props.disabled : false} onSelect={this.onYearchange} className='calenderOptions btnText'>
                        {this.props.yearList.map((item, index) => {
                            return (
                            <MenuItem key={index} id="yearList" eventKey={JSON.stringify(item) + '+yearList'} className={id === "yearList" ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t(item.YEAR)}</MenuItem>
                            );
                        })}
                    </DropdownButton>
                </div>
                : null
            }
                
            <div className={styles.dropdownWrapper}>
                <Modal className={stylesModal.warningModal} id="dateSelvalModal" isOpen={this.state.showValidation} onAfterOpen={this.afterOpenModal}>
                    <div ref="errorMSG" className="mdlWrap" >
                    <div className={`${stylesModal.header} header`} >{i18next.t("warning")}
                        <span className={`${stylesModal.closeImg} closeIcon`} onClick={this.closeValidationModal}>
                          <MUIIconWithTooltip icon={'Close'} className="closeBtn commonCloseIcon" title={i18next.t("close")}/>
                        </span>
                    </div>
                    <div className={`${stylesModal.msg} commonMsgDir`} >
                        <h4>{i18next.t((this.state.validationMsg))}</h4>
                    </div>
                    </div>
                </Modal>
                <OutsideAlerter keyValue={keyValue}>
                    <div 
                        style={{ "display": openCalender ? "block" : "none" }}
                        className={
                            component !== 'Chart' ?
                            `${styles.calendarDiv} chartCalendarDiv rptCalendarDiv ` + this.props.selectedCssColor :
                            `${styles.chartCalendarDiv} chartCalendarDiv graphCalendarDiv ` + this.props.selectedCssColor
                        } 
                        id="reactCal" 
                    >
                        <div className={`${styles.startClndr} startClndr`}>
                            <span className="dateType" >{i18next.t("startDate")}</span>
                            <Calendar onChange={this.onStartDateChange} value={new Date(this.state.startDate)} minDate={this.minDate()} maxDate={this.maxDate()} />
                        </div>
                        <div className={`${styles.endClndr} endClndr`}>
                            <span className="dateType" >{i18next.t("endDate")}</span>
                            <Calendar onChange={this.onEndDateChange} value={new Date(this.state.endDate)} minDate={new Date(this.state.startDate)} maxDate={this.maxDate()} />
                        </div>
                        <div className={`${styles.btnDiv} datepickerBtn`}>
                            <button onClick={this.applyDate} className={`${styles.applyBtn} applyBtn`}>{i18next.t("apply")}</button>
                            <button onClick={this.onCancelDate} className={`${styles.cancelBtn} cancelBtns`}>{i18next.t("cancel")}</button>
                        </div>
                    </div>
                </OutsideAlerter>
                {component !== 'Chart' && this.state.isPrevYearDate ?
                    <Button id="bg-nested-dropdown" onClick={() => this.showCalender("prevYearDate")} disabled={this.props.disabled ? this.props.disabled : false} className={`${styles.dateSelectorBtn} calenderOptions btnText`}>{this.state.showCalendarTitle}</Button>
                    :
                    component !== 'Chart' && !this.state.isPrevYearDate ?
                    <DropdownButton title={this.state.showCalendarTitle} id="bg-nested-dropdown" disabled={this.props.disabled ? this.props.disabled : false} onSelect={this.showCalender} className={`${styles.dateSelectorBtn} calenderOptions btnText`}>
                        {this.props.component !== "DeliveryCompleted" ? <MenuItem id="today" eventKey="today" className={id === 'today' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("today")}</MenuItem> : null}
                        {this.props.component !== "DeliveryCompleted" ? <MenuItem id="last7Days" eventKey="last7Days" className={id === 'last7Days' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last7Days")}</MenuItem> : null}
                        <MenuItem id="last30Days" eventKey="last30Days" className={id === 'last30Days' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last30Days")}</MenuItem>
                        <MenuItem id="last90Days" eventKey="last90Days" className={id === 'last90Days' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last90Days")}</MenuItem>
                        <MenuItem id="custom" eventKey="custom" className={id === 'custom' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("customRange")}</MenuItem>
                    </DropdownButton>
                    :
                    <DropdownButton title={this.state.showCalendarTitle} id="bg-nested-dropdown" onSelect={this.showCalender} className='chrtoptions chrtDropdown'>
                        <MenuItem id="last7Days" eventKey="last7Days" className={id === 'last7Days' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last7Days")}</MenuItem>
                        <MenuItem id="last30Days" eventKey="last30Days" className={id === 'last30Days' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last30Days")}</MenuItem>
                        <MenuItem id="last3Months" eventKey="last3Months" className={id === 'last3Months' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last3Months")}</MenuItem>
                        <MenuItem id="last6Months" eventKey="last6Months" className={id === 'last6Months' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last6Months")}</MenuItem>
                        <MenuItem id="last1Year" eventKey="last1Year" className={id === 'last1Year' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("last1Year")}</MenuItem>
                        <MenuItem id="custom" eventKey="custom" className={id === 'custom' ? `${styles.activeClass} activeClass menuItem liActive` : 'menuItem'}>{i18next.t("customRange")}</MenuItem>
                    </DropdownButton>
                }
            </div>            
        </div>
    );
  }
}
